import styles from "./inpostMap.module.scss";
import React, {CSSProperties} from "react";
import InpostGeowidget, {InpostPointType} from "../inpost-geowidget/inpost-geowidget";

export default function InpostMap(props: inpostMapProps) {
    return <div style={props.style} className={`${styles.wrapper} ${props.className}`}>
        <InpostGeowidget
            token={process.env.REACT_APP_INPOST_TOKEN!}
            language={"pl"}
            config={"parcelCollect"}
            onChange={e => props.onChange?.(e)}
        />
    </div>
}

interface inpostMapProps {
    className?: string,
    style?: CSSProperties,
    onChange?: (e: InpostPointType) => void;
}